/*----------------------------------------------------------------------------*\
    Read-More
    Simple acessible fold/unfold navigation
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.readMore = {
    init: function () {
        if (oy.cutsMustard) {
            this.setup(document);
        }
    },

    setup: function ($context) {
        var self = this;
        var $elements = $context.querySelectorAll('.js--readmore');

        for (var i = 0; i < $elements.length; ++i) {
            var $element = $elements[i];
            self.setupReadmore($element);
        }
    },


    setupReadmore: function ($element) {
        var self = this;
        if($element && !$element.classList.contains('is-initialised')) {
            var $toggle = $element.querySelector('.js--readmore__toggle');
            var $content = $element.querySelector('.js--readmore__content');
            var $focusable = $content.querySelectorAll('a, button, input');

            self.checkSize($element);

            $toggle.addEventListener('click', function () {
                if ($element.classList.contains('is-open')) {
                    $element.classList.remove('is-open');
                    self.removeFocusable($focusable);
                } else {
                    $element.classList.add('is-open');
                    self.restoreFocusable($focusable);
                }

                /**
                 * If the page is embedded, update the height
                 */
                window.dispatchEvent(oy.settings.embedHeightChange);
            });

            $element.classList.add('is-initialised');
        }
    },

    updateOnResize: function ($context) {
        if (oy.cutsMustard) {
            var self = this;
            var $elements = $context.querySelectorAll('.js--readmore');

            for (var i = 0; i < $elements.length; ++i) {
                var $element = $elements[i];
                self.checkSize($element);
            }
        }
    },

    checkSize: function ($element) {
        var self = this;
        var $content = $element.querySelector('.js--readmore__content');
        var $contentInner = $element.querySelector('.js--readmore__content__inner');
        var $focusable = $content.querySelectorAll('a, button, input');

        var contentLineHeight = parseFloat(window.getComputedStyle($contentInner, null).getPropertyValue('line-height'));
        var initHeight = contentLineHeight * parseFloat($element.dataset.lines);

        if ($contentInner.scrollHeight > initHeight) {
            $element.classList.add('is-active');
            if (!$element.classList.contains('is-open')) {
                self.removeFocusable($focusable);
            }
        } else {
            $element.classList.remove('is-active');
            self.restoreFocusable($focusable);
        }

        window.dispatchEvent(oy.settings.embedHeightChange);
    },

    /**
     * Removes focus state on all focusable elements
     */
    removeFocusable: function ($focusable) {
        for (var i = 0; i < $focusable.length; ++i) {
            $focusable[i].setAttribute('tabindex', '-1');
        }
    },

    /**
     * Restores focus state on all focusable elements
     */
    restoreFocusable: function ($focusable) {
        for (var i = 0; i < $focusable.length; ++i) {
            $focusable[i].removeAttribute('tabindex');
        }
    }
};


window.addEventListener('optimizedResize', function() {
    oy.readMore.updateOnResize(document);
});

window.addEventListener('load', function () {
    oy.readMore.init();
    oy.readMore.updateOnResize(document);
}, false);



window.addEventListener('DOMContentLoaded', function () {
    oy.readMore.updateOnResize(document);
}, false);